import cx from 'clsx';
import React from 'react';

import { ReactComponent as CloseIcon } from '@assets/svg/cross.svg';

import useTranslation from '@hooks/useTranslation';

import { selectAppRtl } from '@store/useAppStore';
import { selectSecondaryModal, useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

interface IProps {
  title?: string;
  variant?: 'withoutSeparator' | 'woClose';
  onClose?: () => void;
}

const ModalHeader: React.FC<IProps> = ({ title = '', variant = '', onClose }) => {
  const { t } = useTranslation();
  const rtl = selectAppRtl();

  const { name: secondaryModalName } = selectSecondaryModal();
  const { setModalClose, setSecondaryModalClose } = useModalActions();

  const handleClose = () => {
    if (onClose) {
      onClose();

      return;
    }

    if (secondaryModalName) {
      setSecondaryModalClose();
    } else {
      setModalClose();
    }
  };

  return (
    <div className={cx(style.modalHead, { [style.withoutSeparator]: variant === 'withoutSeparator' })}>
      <div className={style.modalHeadTitle}>{t(title)}</div>
      {variant !== 'woClose' && (
        <CloseIcon className={cx(style.closeIcon, { [style.rtl]: rtl })} onClick={handleClose} />
      )}
    </div>
  );
};

export default ModalHeader;
